import { z } from 'zod/v3';
import { transformNull, zIsoDate } from '../../common/utils';
import { zIsoDateTime } from '../../common/utils/schema/zIsoDateTime';
import { SystemClassifierItemSchema } from '../../systemClassifier';
import { UserSearchResultSchema } from '../../user/schema/formData/UserFormDataSchema';
import { DataRowSchema } from './InputDataSchema';
import { SampleCommentsSchema } from './SampleCommentSchema';
import { SampleCommentType, SamplePeriodType } from './types';

export const LoadingStatusSchema = z.enum(['OK', 'NO_VERSIONS', 'NO_SAMPLE']);

export const CommentsSchema = z.object({
  comments: z.string().nullable(),
  modifiedAt: zIsoDateTime().nullable(),
  modifiedBy: z.number().nullable(),
  modifiedUsername: z.string().nullable(),
});

export const SubmittedDataVersionSchema = z.object({
  id: z.number().nullable(),
  descriptionId: z.number(),
  dataModifiedAt: zIsoDateTime().nullable(),
  dataModifiedBy: UserSearchResultSchema.nullable(),
  isActive: z.boolean().nullable(),
  isLocked: z.boolean().nullable(),
  statusId: z.number().nullable(),
  status: SystemClassifierItemSchema.nullable(), // DATA_LOADING_STATUS
  dataStatusId: z.number().nullable(),
  dataStatus: SystemClassifierItemSchema.nullable(), // SUBMITTED_DATA_STATUS
  comments: z.string().nullable(),
  commentsModifiedAt: zIsoDateTime().nullable(),
  commentsModifiedBy: UserSearchResultSchema.nullable(),
  activeVersion: z.boolean().nullable(),
  draftVersion: z.boolean().nullable(),
});

export const GroupDescriptionSchema = z.object({
  id: z.number().nullable(),
  activeVersionId: z.number().nullable(),
  code: z.string(),
  name: z.string(),
  modifiedAt: z.string().nullable(),
  modifiedBy: UserSearchResultSchema.nullable(),
  sampleLocked: z.boolean(),
  locked: z.boolean(),
  active: z.boolean(),
  versions: z.array(SubmittedDataVersionSchema).nullable(),
});

export const SamplePeriodSchema = z.object({
  from: z.string(),
  to: z.string(),
});

export const InputDataDetailsSchema = z.object({
  dataObjectGroupId: z.number().nullable(),
  dataObjectGroupCode: z.string().nullable(),
  dataObjectGroupName: z.string().nullable(),
  dataObjectSystemicGroupId: z.number().nullable(),

  valueDate: zIsoDate(),

  dataSubjectId: z.number(),
  dataSubjectCode: z.string(),
  dataSubjectName: z.string(),

  frequency: SystemClassifierItemSchema.nullable(),

  dataManagerId: z.number().nullable(),
  dataManagerUsername: z.string().nullable(),

  subjectComments: CommentsSchema.nullable(),

  descriptions: z.array(GroupDescriptionSchema).optional(),

  sampleId: z.number().nullable(),
  loadingStatus: LoadingStatusSchema,
  sampleComments: transformNull<SampleCommentType[]>(
    SampleCommentsSchema.array(),
    [],
  ),
  samplePeriods: transformNull<SamplePeriodType[]>(
    SamplePeriodSchema.array(),
    [],
  ),
});

export const DataUpdateSchema = z.object({
  statusId: z.number().nullish(),
  status: SystemClassifierItemSchema.nullish(), // DATA_LOADING_STATUS
  dataStatusId: z.number().nullable(),
  dataStatus: SystemClassifierItemSchema.nullable(), // SUBMITTED_DATA_STATUS,
  dataModifiedAt: zIsoDateTime().nullable(),
  dataModifiedById: z.number().nullable(),
  dataModifiedBy: UserSearchResultSchema.nullable(),
});

export const InputUpdateResponseSchema = z.object({
  rows: z.array(DataRowSchema).nullable(),
  updateInfo: DataUpdateSchema.nullish(),
});

export const InputCommentsUpdateResponseSchema = z.object({
  comments: z.array(SampleCommentsSchema),
});
